import Sentry from '../sentry';
import { handleForbidden } from '@/helpers';

const errorHandler = (error) => {
    if([400, 500].includes(error?.response?.status)) {
        Sentry.captureException(error);
    }
}

const onError = async (error) => {
    if(error?.response?.status === 401) {
        window.location = '/login';
    }

    if(error?.response?.status === 403) {
        handleForbidden();
    }

    if(error?.response?.status === 422) {
        const { data } = error.response;

        data?.message && typeof data.message === 'string' && dispatchEvent(new CustomEvent("notify", { detail: { text: data.message, type: "warning" }}));
    }

    errorHandler(error);

    return Promise.reject(error);
}

const onSuccess = (response) => {
    return response;
}

export { onError, onSuccess };